<template>
  <section class="qgen-progress" aria-label="题目处理进度">
    <div class="qgen-progress-head">
      <div>
        <strong>{{ stageLabel }}</strong>
        <span v-if="task.current_chapter">第 {{ task.current_chapter }} 章</span>
      </div>
      <span>{{ task.reviewed_count || 0 }} / {{ task.estimated_total || task.split_count || 0 }}</span>
    </div>
    <el-progress :percentage="percentage" :status="progressStatus" />
    <div class="qgen-counter-grid">
      <div><span>已切分</span><strong>{{ task.split_count || 0 }}</strong></div>
      <div><span>已规范</span><strong>{{ task.normalized_count || 0 }}</strong></div>
      <div><span>已补答案</span><strong>{{ task.answered_count || 0 }}</strong></div>
      <div><span>已复核</span><strong>{{ task.reviewed_count || 0 }}</strong></div>
      <div><span>待人工确认</span><strong>{{ task.pending_manual_count || 0 }}</strong></div>
      <div><span>异常</span><strong class="is-danger">{{ task.failed_count || 0 }}</strong></div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  task: { type: Object, default: () => ({}) }
})

const stageLabels = {
  queued: '等待处理', preflighting: '正在预审文档', splitting: '正在切分题目',
  normalizing: '正在规范题目', answering: '正在补全答案', reviewing: '正在独立复核',
  validating: '正在执行本地校验', ready_for_manual_review: '等待人工确认',
  committing: '正在写入题库', succeeded: '处理完成', partially_succeeded: '部分完成',
  failed: '处理失败', cancelling: '正在结束', cancelled: '已结束'
}

const stage = computed(() => props.task.current_stage || props.task.status || 'queued')
const stageLabel = computed(() => stageLabels[stage.value] || '处理中')
const percentage = computed(() => {
  const total = Number(props.task.estimated_total || props.task.split_count || 0)
  const current = Number(props.task.reviewed_count || props.task.answered_count || props.task.normalized_count || props.task.split_count || 0)
  return total ? Math.max(0, Math.min(100, Math.round((current / total) * 100))) : 0
})
const progressStatus = computed(() => stage.value === 'succeeded' ? 'success' : (stage.value === 'failed' ? 'exception' : undefined))
</script>

<style scoped>
.qgen-progress { padding: 14px 0; border-top: 1px solid #ebeef5; border-bottom: 1px solid #ebeef5; }
.qgen-progress-head { display: flex; justify-content: space-between; gap: 12px; margin-bottom: 10px; color: #303133; font-size: 13px; }
.qgen-progress-head div { display: flex; gap: 10px; }
.qgen-progress-head span { color: #909399; }
.qgen-counter-grid { display: grid; grid-template-columns: repeat(6, minmax(78px, 1fr)); gap: 8px; margin-top: 12px; }
.qgen-counter-grid div { min-width: 0; padding: 8px 10px; border-left: 2px solid #dcdfe6; background: #f7f8fa; }
.qgen-counter-grid span, .qgen-counter-grid strong { display: block; line-height: 1.4; }
.qgen-counter-grid span { color: #909399; font-size: 11px; }
.qgen-counter-grid strong { color: #303133; font-size: 16px; }
.qgen-counter-grid .is-danger { color: #f56c6c; }
@media (max-width: 760px) { .qgen-counter-grid { grid-template-columns: repeat(3, minmax(72px, 1fr)); } }
</style>
